import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import * as Highcharts from "highcharts";
import {
  VAIconRegistryService,
  infoCircle,
  chevronDown,
  redo,
  download,
} from "@va/core-library/icons";
import { PharmaDataService } from "../pharma-data.service";
// import { Chart } from "highcharts";
import {
  GlobalHighchartOptions,
  NoDataMsg,
  RangeChartOptions,
} from "../pharma-page.model";
import { ActivatedRoute } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { formatCell } from "src/app/utils/common";

import { AppService } from "src/app/app.service";
@Component({
  selector: "app-drug-distribution-analysis-chart",
  templateUrl: "./drug-distribution-analysis-chart.component.html",
  styleUrls: ["./drug-distribution-analysis-chart.component.scss"],
})
export class DrugDistributionAnalysisChartComponent {
  loading = true;
  showError = false;
  highcharts = Highcharts;
  chartOptions: Highcharts.Options;
  chartReady = false;
  errorMessage = NoDataMsg;
  updateFlag = false;
  // isExcluded:boolean;
  chart: Highcharts.Chart;

  dataObservable: Observable<any>;
  chartDataObservable: Observable<any>;
  rangeChartOptions = RangeChartOptions;

  chartData;
  dataObj;
  chartName = "Test chart";
  switchValue: boolean = false;
  visible: boolean;
  searchTerm;
  filteredBrokers: any[] = [];
  downloadOptVisible = false;
  brokerList = [];
  brokerCount;
  checkboxStates: boolean[] = [];
  excludedBrokers: boolean[] = [];
  selectedBrokerId = [];
  completeBrokerId = [];
  brokerId = [];
  selectedItem = null;
  highLowPeriod = null;
  forecastPeriodData = {};
  cTagId;
  routeSubscriber: Subscription;
  @Input() dataSettings;
  @Input() dataCall;
  @Input() sourceCall;
  @Output() onChartInstance: EventEmitter<Highcharts.Chart> =
    new EventEmitter();

  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  constructor(
    private pharmaService: PharmaDataService,
    private iconRegistryService: VAIconRegistryService,
    private route: ActivatedRoute,
    private appService: AppService,
  ) {
    this.iconRegistryService.registerIcons([
      infoCircle,
      download,
      redo,
      chevronDown,
    ]);
  }
  @HostListener("window:resize", [])
  sizeChange() {
    this.updateFlag = true;
    if (this.chart) {
      setTimeout(() => {
        this.onChartInstance.emit(this.chart);
      }, 50);
    }
  }
  ngOnInit() {
    this.routeSubscriber = this.route.params.subscribe((param) => {
      try {
        if (param.cTagId) {
          this.cTagId = parseInt(param.cTagId);
        } else {
          console.error("Ctagid is mandatory in route param");
        }
      } catch (e) {
        console.error("Invalid ctagid ", e);
      }
    });
    Highcharts.setOptions(GlobalHighchartOptions);

    //Adding Consensus to broker list as well
    if (this.sourceCall["broker_data"]) {
      this.sourceCall["broker_data"].forEach((brokerId) => {
        if (
          !this.brokerList.some(
            (existingBroker) => existingBroker.id === brokerId.id,
          )
        ) {
          if (!brokerId.excluded) {
            this.brokerList.push({
              name: brokerId["name"],
              exclude: brokerId["excluded"],
              id: brokerId["id"],
              checked: false,
            });
          } else {
            this.brokerList.push({
              name: `${brokerId["name"]}   (Ex)`,
              exclude: brokerId["excluded"],
              id: brokerId["id"],
              checked: false,
            });
          }
        }
        if (!this.brokerId.includes(brokerId["id"])) {
          this.brokerId.push(brokerId["id"]);
        }
      });
      this.sourceCall["broker_data"].forEach((brokerId) => {
        if (
          brokerId["selected"] &&
          !this.selectedBrokerId.includes(brokerId["id"])
        ) {
          this.selectedBrokerId.push(brokerId["id"]);
        }
      });
    }
  }
  showSelectedBrokerData() {
    this.selectedBrokerId.forEach((brokerId) => {
      if (brokerId === "highlow") {
        this.chart.addSeries({
          name: "High/Low",
          data: this.highLowPeriod,
          type: "arearange",
          color: "rgba(216, 237, 250, 0.50)",
          zIndex: -999,
          dashStyle: "DashDot",
          lineColor: "#146496",
          marker: {
            symbol: "circle", // Set marker shape (you can change this)
            radius: 4, // Set marker radius
            fillColor: "#146496", // Set marker fill color
            lineColor: "#146496", // Set marker border color
          },
        });
      } else {
        const item = this.dataCall[brokerId];
        const temp = {};
        temp["data"] = [];
        Object.keys(item.period).forEach((itemPeriod) => {
          temp["data"].push([itemPeriod, item.period[itemPeriod]]);
        });
        temp["name"] = item.meta.short_name;
        temp["type"] = "line";
        this.chart.addSeries({
          data: temp["data"],
          name: temp["name"],
          type: temp["type"],
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.dataCall && changes.dataCall.currentValue) {
      if (!this.brokerId.includes(13001)) {
        this.brokerList.push({
          name: this.dataCall[13001]["meta"]["short_name"],
          id: 13001,
          checked: true,
          disabled: true,
        });
        if (!this.selectedBrokerId.includes(13001)) {
          this.selectedBrokerId.push(13001);
        }
        this.brokerId.push(13001);
      }

      if (!this.brokerId.includes("highlow")) {
        this.brokerList.push({
          name: "High/Low",
          id: "highlow", // Use a unique identifier for 'High/Low'
          checked: true,
          disabled: true,
        });
        if (!this.selectedBrokerId.includes("highlow")) {
          this.selectedBrokerId.push("highlow");
        }
        this.brokerId.push("highlow");
      }

      this.getChartData(
        this.dataCall,
        changes.dataCall.previousValue ? true : false,
      );
      this.updateFlag = true;
    }
    if (changes && changes.sourceCall && changes.sourceCall.currentValue) {
      this.selectedBrokerId = [];
      if (changes.sourceCall.currentValue && changes.sourceCall.previousValue) {
        if (
          changes.sourceCall.currentValue["broker_data"].length <
          changes.sourceCall.previousValue["broker_data"].length
        ) {
          this.brokerId = [];
          changes.sourceCall.currentValue["broker_data"].forEach((item) => {
            this.brokerId.push(item.id);
          });
          this.brokerList = changes.sourceCall.currentValue["broker_data"];
        }
      }
      if (changes.sourceCall.currentValue["broker_data"]) {
        changes.sourceCall.currentValue["broker_data"].forEach((item) => {
          if (item["selected"] && !this.selectedBrokerId.includes(item["id"])) {
            this.selectedBrokerId.push(item["id"]);
          }
          if (!this.brokerId.includes(item["id"])) {
            this.brokerId.push(item["id"]);
          }
          if (
            !this.brokerList.some(
              (existingBroker) => existingBroker.id === item["id"],
            )
          ) {
            this.brokerList.push({
              name: item["name"],
              exclude: item["excluded"],
              id: item["id"],
              checked: false,
              disabled: false,
            });
          }
        });
      }
      if (!this.selectedBrokerId.includes(13001)) {
        this.selectedBrokerId.push(13001);
      }
      if (!this.selectedBrokerId.includes("highlow")) {
        this.selectedBrokerId.push("highlow");
      }
    }
  }

  onChartReset() {
    this.selectedBrokerId = [];
    this.brokerList = [];
    this.sourceCall["broker_data"].forEach((brokerId) => {
      if (brokerId["selected"]) {
        this.selectedBrokerId.push(brokerId["id"]);
      }
      this.brokerList.push({
        name: brokerId["name"],
        exclude: brokerId["excluded"],
        id: brokerId["id"],
        checked: brokerId["selected"],
        disabled: false,
      });
    });

    this.selectedBrokerId.push(13001);
    this.selectedBrokerId.push("highlow");
    this.brokerList.push({
      name: this.dataCall[13001]["meta"]["short_name"],
      id: 13001,
      checked: true,
      disabled: true,
    });
    this.brokerList.push({
      name: "High/Low",
      id: "highlow", // Use a unique identifier for 'High/Low'
      checked: true,
      disabled: true,
    });
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(true);
    }
    // this.chartOptions.series = [];
    this.showSelectedBrokerData();
    this.getChartData(this.dataCall);
    this.updateFlag = true;
    if (this.chart) {
      setTimeout(() => {
        this.onChartInstance.emit(this.chart);
      }, 50);
    }
    this.pharmaService.logUserAction(
      "SOURCES_RESET",
      {
        drugCtag: this.cTagId,
      },
      "BIOPHARMA_DISTRIBUTION_PAGE",
    );
  }
  onCheckboxChange(broker, checked, index) {
    this.brokerList[index]["checked"] = checked === true ? true : false;
    let indexChanged = -1;
    if (checked) {
      indexChanged = this.selectedBrokerId.push(broker["id"]) - 1;
    } else {
      indexChanged = this.selectedBrokerId.indexOf(broker["id"]);
      this.selectedBrokerId = this.selectedBrokerId.filter(
        (id) => id !== broker["id"],
      );
    }
    this.updateChartData(broker, checked, indexChanged);
    this.pharmaService.logUserAction(
      "SOURCES_CHANGE",
      {
        drugCtag: this.cTagId,
        sources: this.brokerList,
      },
      "BIOPHARMA_DISTRIBUTION_PAGE",
    );
  }

  getChartData(dataObj, isUpdate?) {
    // this.forecastPeriodData = dataObj["meta"]["isforcast"];
    this.chartOptions = this.appService.superClone(RangeChartOptions);
    this.chartOptions.plotOptions.series.stickyTracking = false;
    this.chartOptions.plotOptions.series.marker.enabled = this.switchValue;
    if (
      this.dataSettings &&
      this.dataSettings["periodData"] &&
      this.dataSettings["periodData"]["period"]
    ) {
      const period_with_forecast = [];
      this.dataSettings["periodData"]["period"].forEach((period) => {
        const isforcast = dataObj["meta"]["isforcast"][`${period}`] ? "E" : "";
        period_with_forecast.push(period + isforcast);
      });
      this.chartOptions.xAxis["categories"] = [...period_with_forecast];
    }
    this.brokerCount = Object.keys(dataObj.sorted_ids).length;
    const sorted_list =
      dataObj.sorted_ids.length === 0 ? ["13001"] : dataObj.sorted_ids;
    sorted_list.forEach((brokerId) => {
      if (
        dataObj &&
        dataObj[brokerId]["meta"] &&
        dataObj[brokerId]["meta"]["short_name"]
      )
        if (dataObj[brokerId] && dataObj[brokerId].exclude) {
          //exxcluded labels
          const isExcluded: boolean = dataObj[brokerId].exclude;
          if (isExcluded) {
            this.excludedBrokers.push(brokerId);
          }
        }
      const dataRef = this.formatCellValue;
      this.chartOptions.tooltip = {
        useHTML: true,
        backgroundColor: "rgba(255,255,255,1)",
        valueDecimals: 2,
        formatter: function () {
          let html = null;
          const metaObj = {
            ...dataObj[brokerId]["meta"],
            currency: "",
          };
          const parts = this.series.name.split(" ");
          const coloredText =
            `<span>${parts[0]}</span>` +
            `<span style="font-style:italic;color:#667284;">${parts
              .slice(1)
              .join(" ")}</span>`;

          let lowFormatted = dataRef(metaObj, this.point.options.low);
          lowFormatted =
            dataObj[brokerId]["meta"]["currency"] +
            dataObj[brokerId]["meta"]["magnitude"] +
            lowFormatted;

          let highFormatted = dataRef(metaObj, this.point.options.high);
          highFormatted =
            dataObj[brokerId]["meta"]["currency"] +
            dataObj[brokerId]["meta"]["magnitude"] +
            highFormatted;

          let yFormatted = dataRef(metaObj, this.y);
          yFormatted =
            dataObj[brokerId]["meta"]["currency"] +
            dataObj[brokerId]["meta"]["magnitude"] +
            yFormatted;

          const periodData = dataObj["meta"]["isforcast"];
          const contextObject = this as {
            series: { name: string };
            x: string;
            y: number;
            forecastPeriodData?: boolean;
          };
          if (contextObject.series.name === "High/Low") {
            let x = this.x;
            if (`${this.x}`.endsWith("E")) {
              x = `${this.x}`.substring(0, `${this.x}`.length - 1);
            }
            if (!periodData[x]) {
              html = `<b>VA Actuals</b><br/>${this.x}<br/>High:
                ${highFormatted}<br>Low:
                 ${lowFormatted}`;
            } else {
              html = `<b>${coloredText}</b><br/>${this.x}<br/>High:
                ${highFormatted}<br>Low:
                ${lowFormatted}`;
            }
          } else if (contextObject.series.name === "Consensus") {
            let x = this.x;
            if (`${this.x}`.endsWith("E")) {
              x = `${this.x}`.substring(0, `${this.x}`.length - 1);
            }
            if (!periodData[x]) {
              html = `<b>VA Actuals</b><br/>${this.x}<br/>${yFormatted}`;
            } else {
              html = `<b>${coloredText}</b><br/>${this.x}<br/>${yFormatted}`;
            }
          } else {
            html = `<b>${coloredText}</b><br/>${this.x}<br/>${yFormatted}`;
          }
          return html;
        },
      };

      this.chartOptions.yAxis["title"].text =
        ` Consensus/VA Actuals (${dataObj[brokerId]["meta"]["currency"]}${dataObj[brokerId]["meta"]["magnitude"]}) `;
    });

    this.completeBrokerId = [];
    if (dataObj && dataObj["sorted_ids"]) {
      this.selectedBrokerId.forEach((item) => {
        if (this.brokerId.includes(item) && item !== "highlow") {
          this.completeBrokerId.push(item);
          const i = this.brokerList.findIndex(
            (brokerItem) => brokerItem.id === item,
          );
          if (i !== -1) this.brokerList[i]["checked"] = true;
        }
        // this.checkboxStates.push(isChecked);
      });

      const fiscalYears = this.dataSettings["periodData"]["period"];

      const minPeriod = fiscalYears.map((year) => {
        return dataObj["min"]["period"][year]["value"];
      });

      const maxPeriod = fiscalYears.map((year) => {
        return dataObj["max"]["period"][year]["value"];
      });

      const consensus = fiscalYears.map((year) => {
        return dataObj[13001]["period"][year]["value"];
      });
      this.highLowPeriod = minPeriod.map((minValue, index) => {
        const min = minValue !== null ? minValue : consensus[index];
        const max =
          maxPeriod[index] !== null ? maxPeriod[index] : consensus[index];
        return [min, max];
      });

      if (isUpdate) {
        this.updateChartData(
          undefined,
          undefined,
          undefined,
          this.highLowPeriod,
        );
      } else {
        const sIds = JSON.parse(JSON.stringify(this.completeBrokerId));
        const lineSeries = sIds.map((brokerId) => {
          const item = dataObj[brokerId];
          const temp = {};
          temp["data"] = [];
          Object.keys(item.period).forEach((itemPeriod) => {
            temp["data"].push([
              itemPeriod,
              item.period[itemPeriod] ? item.period[itemPeriod]["value"] : null,
            ]);
          });
          if (item.exclude) {
            temp["name"] = `${item.meta.short_name}   (Ex)`;
          } else {
            temp["name"] = item.meta.short_name;
          }
          temp["type"] = "line";
          if (brokerId === 13001) {
            temp["color"] = "#333942"; // Set line color to black
            temp["dashStyle"] = "dash"; // Set line style to dashed
          }
          return { ...temp };
        });
        lineSeries.push({
          name: "High/Low",
          data: this.highLowPeriod,
          type: "arearange",
          color: "rgba(216, 237, 250, 0.50)",
          zIndex: -999,
          dashStyle: "DashDot",
          lineColor: "#146496",
          marker: {
            symbol: "circle", // Set marker shape (you can change this)
            radius: 4, // Set marker radius
            fillColor: "#146496", // Set marker fill color
            lineColor: "#146496", // Set marker border color
          },
        });
        this.chartOptions.series = lineSeries;
      }
    }
    setTimeout(() => {
      this.chartReady = true;
    }, 0);
    this.chartOptions.exporting.filename = `Distribution-${dataObj["meta"]["drug_name"]}-Chart`;
    this.chartOptions.exporting.chartOptions.title.text = `Distribution|${dataObj["meta"]["drug_name"]}|${dataObj["meta"]["ticker"]}`;
    this.chartName = `Distribution|${dataObj["meta"]["drug_name"]}|${dataObj["meta"]["ticker"]}`;
  }
  updateChartData(broker?, added?, indexChanged?, highLowPeriod?) {
    if (this.dataCall && this.dataCall["sorted_ids"]) {
      if (indexChanged !== undefined) {
        this.selectedBrokerId.forEach((item) => {
          if (this.brokerId.includes(item)) {
            const i = this.brokerList.findIndex(
              (brokerItem) => brokerItem.id === item,
            );
            if (i !== -1) this.brokerList[i]["checked"] = true;
          }
          // this.checkboxStates.push(isChecked);
        });
        if (added) {
          const item = this.dataCall[broker["id"]];
          const temp = {};
          temp["data"] = [];
          Object.keys(item.period).forEach((itemPeriod) => {
            temp["data"].push([
              itemPeriod,
              item.period[itemPeriod] ? item.period[itemPeriod]["value"] : null,
            ]);
          });
          if (item.exclude) {
            temp["name"] = `${item.meta.short_name}   (Ex)`;
          } else {
            temp["name"] = item.meta.short_name;
          }
          temp["type"] = "line";
          if (broker["id"] === 13001) {
            this.chart.addSeries({
              data: temp["data"],
              name: temp["name"],
              type: temp["type"],
              color: "#333942",
              dashStyle: "Dash",
            });
            this.chartOptions.series.push({
              data: temp["data"],
              name: temp["name"],
              type: temp["type"],
              color: "#333942",
              dashStyle: "Dash",
            });
          } else {
            this.chart.addSeries({
              data: temp["data"],
              name: temp["name"],
              type: temp["type"],
            });
            this.chartOptions.series.push({
              data: temp["data"],
              name: temp["name"],
              type: temp["type"],
            });
          }
        } else {
          this.chart.series[indexChanged].remove();
          this.chartOptions.series = this.chartOptions.series.splice(
            indexChanged,
            1,
          );
        }
      } else {
        const sIds = JSON.parse(JSON.stringify(this.completeBrokerId));
        while (this.chart.series.length > 0) {
          this.chart.series[0].remove(true);
          this.chartOptions.series = this.chartOptions.series.splice(0, 1);
        }
        sIds.forEach((brokerId) => {
          const item = this.dataCall[brokerId];
          const data = [];
          Object.keys(item.period).forEach((itemPeriod) => {
            data.push([
              itemPeriod,
              item.period[itemPeriod] ? item.period[itemPeriod]["value"] : null,
            ]);
          });
          if (brokerId === 13001) {
            this.chart.addSeries({
              name: item["meta"]["short_name"],
              type: "line",
              data: data,
              color: "#333942",
              dashStyle: "Dash",
            });
            this.chartOptions.series.push({
              name: item["meta"]["short_name"],
              type: "line",
              data: data,
              color: "#333942",
              dashStyle: "Dash",
            });
          } else {
            this.chart.addSeries({
              name: item["exclude"]
                ? `${item["meta"]["short_name"]}   (Ex)`
                : item["meta"]["short_name"],
              type: "line",
              data: data,
            });
            this.chartOptions.series.push({
              name: item["exclude"]
                ? `${item["meta"]["short_name"]}   (Ex)`
                : item["meta"]["short_name"],
              type: "line",
              data: data,
            });
          }
        });
        this.chart.addSeries({
          name: "High/Low",
          data: highLowPeriod,
          type: "arearange",
          color: "rgba(216, 237, 250, 0.50)",
          zIndex: -999,
          dashStyle: "DashDot",
          lineColor: "#146496",
          marker: {
            symbol: "circle", // Set marker shape (you can change this)
            radius: 4, // Set marker radius
            fillColor: "#146496", // Set marker fill color
            lineColor: "#146496", // Set marker border color
          },
        });
        this.chartOptions.series.push({
          name: "High/Low",
          data: highLowPeriod,
          type: "arearange",
          color: "rgba(216, 237, 250, 0.50)",
          zIndex: -999,
          dashStyle: "DashDot",
          lineColor: "#146496",
          marker: {
            symbol: "circle", // Set marker shape (you can change this)
            radius: 4, // Set marker radius
            fillColor: "#146496", // Set marker fill color
            lineColor: "#146496", // Set marker border color
          },
        });
      }
    }
  }
  searchAllBrokers(query: string) {
    // console.log("result search",this.searchTerm);
    query = query.toLowerCase();
    this.filteredBrokers = this.brokerList.filter((item) => {
      const itemName = item["name"].toLowerCase();
      return itemName.includes(query);
    });
    // console.log("Result", this.filteredBrokers);
  }

  onHighchartsChartInstance(chartInstance) {
    this.chart = chartInstance;
  }

  onDistributionPageDataResolved(response) {
    this.chartData = response;
  }

  onError(error) {
    this.errorMessage = error.message;
    this.showError = true;
    return;
  }

  formatCellValue(metaData, value) {
    const newVal = formatCell(
      value,
      metaData.currency,
      metaData.unit,
      "Amount",
    );
    return newVal;
  }

  downloadValue(downloadType: number) {
    this.downloadOptVisible = false;

    // Check if the chart property is defined before accessing its properties
    if (this.chart) {
      this.chart.options.title.text = this.chartName;
      this.chartOptions.title = {
        ...this.chart.options.title,
        text: this.chartName,
      };
      switch (downloadType) {
        case 0:
          this.chart.exportChart(
            {
              type: "image/png",
              filename: this.rangeChartOptions.exporting.filename,
              sourceWidth: 1920,
              sourceHeight: 1080,
            },
            this.chartOptions,
          );
          break;
        case 2:
          this.chart.exportChart(
            {
              type: "application/pdf",
              filename: this.rangeChartOptions.exporting.filename,
              sourceWidth: 1920,
              sourceHeight: 1080,
            },
            this.chartOptions,
          );
          break;
        default:
          break;
      }
    }
  }
  onSwitchChange(switchState: boolean): void {
    this.chart.update({
      plotOptions: {
        series: {
          marker: {
            enabled: switchState, // Change marker settings here dynamically
          },
        },
      },
    });
    this.pharmaService.logUserAction(
      "ACESSIBILITY_CHANGE",
      {
        drugCtag: this.cTagId,
        accessbility: switchState,
      },
      "BIOPHARMA_DISTRIBUTION_PAGE",
    );
  }
  // clickSwitch() {
  //   this.switchValue = !this.switchValue;
  //   this.chart.update({
  //     plotOptions: {
  //       series: {
  //         marker: {
  //           enabled: this.switchValue, // Change marker settings here dynamically
  //         },
  //       },
  //     },
  //   });
  // }
}
